import type { BaseItineraryBlockProps } from './BaseItineraryBlock.js';

import { BaseItineraryBlock } from './BaseItineraryBlock.js';

export function HotelCheckoutBlock({ event, items, size = 'default', className }: BaseItineraryBlockProps) {
  if (event.type !== 'hotel_checkout' || items.length === 0 || items.some((i) => i.type !== 'room')) return null;

  const title = event.originalFormattedTime ? `${event.title} by ${event.originalFormattedTime}` : event.title;

  if (size === 'sm') {
    return <BaseItineraryBlock event={event} items={items} title={title} size={'sm'} className={className} />;
  }

  return (
    <div
      data-print="compact-row"
      className="flex flex-col md:items-center py-8 md:py-12 px-4 md:px-8 border-b text-muted-foreground bg-background-secondary"
    >
      <BaseItineraryBlock event={event} items={items} title={title} size={'sm'} className={className} />
    </div>
  );
}
